import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card, Table, Button, Form, InputGroup, Spinner } from 'react-bootstrap';
import { getApiUrl } from '../config/api';

const MasterPerusahaan = () => {
  const navigate = useNavigate();
  const [time, setTime] = useState({ date: '', clock: '' });

  // Data State
  const [perusahaanList, setPerusahaanList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [fetchError, setFetchError] = useState('');
  
  // Filter & Pagination
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(15);

  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
      setTime({
        date: now.toLocaleDateString('id-ID', options),
        clock: now.toLocaleTimeString('id-ID') + ' WIB'
      });
    };
    updateTime();
    const interval = setInterval(updateTime, 1000);
    
    fetchPerusahaan();
    
    return () => clearInterval(interval);
  }, []);

  const fetchPerusahaan = async () => {
    setIsLoading(true);
    setFetchError('');
    try {
      const response = await fetch(`${getApiUrl()}/show_perusahaan`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const json = await response.json();
      if (json && json.list_perusahaan) {
        setPerusahaanList(json.list_perusahaan);
      }
    } catch (err) {
      console.warn("Gagal terhubung ke backend /show_perusahaan:", err);
      setFetchError("Gagal mengambil data dari server. Pastikan backend aktif.");
    } finally {
      setIsLoading(false);
    }
  };


  // State Data Perujuk
  const [activeTab, setActiveTab] = useState('perusahaan');
  const [perujukList, setPerujukList] = useState([]);
  const [isLoadingPerujuk, setIsLoadingPerujuk] = useState(false);
  const [searchPerujuk, setSearchPerujuk] = useState('');

  const fetchPerujuk = async () => {
    setIsLoadingPerujuk(true);
    setFetchError('');
    try {
      const response = await fetch(`${getApiUrl()}/show_perujuk`);
      const json = await response.json();
      if (json && json.list_perujuk) {
        setPerujukList(json.list_perujuk);
      }
    } catch (err) {
      console.warn("Gagal terhubung ke backend /show_perujuk:", err);
      setFetchError("Gagal mengambil data perujuk.");
    } finally {
      setIsLoadingPerujuk(false);
    }
  };

  useEffect(() => {
    if (activeTab === 'perujuk' && perujukList.length === 0) {
      fetchPerujuk();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);

  const filteredPerujuk = perujukList.filter(item => 
    (item.nama || '').toLowerCase().includes(searchPerujuk.toLowerCase()) ||
    (item.kd_rujuk || '').toLowerCase().includes(searchPerujuk.toLowerCase()) ||
    (item.praktek || '').toLowerCase().includes(searchPerujuk.toLowerCase())
  );

  // Filter
  const filteredData = perusahaanList.filter(item => {
    const q = searchQuery.toLowerCase();
    return (
      (item.perusahaan || '').toLowerCase().includes(q) ||
      (item.kode || '').toLowerCase().includes(q) ||
      (item.pic1 || '').toLowerCase().includes(q) ||
      (item.pic2 || '').toLowerCase().includes(q)
    );
  });

  // Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  // Styling (mengikuti gaya modern light-slate)
  const styles = {
    appContainer: {
      minHeight: '100vh',
      backgroundColor: '#f1f5f9',
      display: 'flex',
      flexDirection: 'column',
      fontFamily: "'Inter', 'Segoe UI', sans-serif"
    },
    navbarCustom: {
      background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
      padding: '0.6rem 1rem',
      boxShadow: '0 2px 12px rgba(0,0,0,0.15)'
    },
    mainContent: {
      flex: 1,
      padding: '1.5rem',
      display: 'flex',
      flexDirection: 'column'
    },
    mainCard: {
      borderRadius: '0.75rem',
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column'
    },
    cardHeader: {
      background: 'linear-gradient(135deg, #0d9488 0%, #0f766e 100%)',
      color: 'white',
      padding: '0.8rem 1.25rem',
      borderBottom: 'none'
    }
  };

  return (
    <div style={styles.appContainer}>
      {/* NAVBAR */}
      <nav className="navbar navbar-expand-xl navbar-dark shadow-sm" style={styles.navbarCustom}>
        <Container fluid>
          <a className="navbar-brand d-flex align-items-center me-3" href="#home" onClick={(e) => { e.preventDefault(); navigate('/home'); }}>
            <div className="d-flex align-items-center justify-content-center me-2 rounded bg-white bg-opacity-10 p-1">
              <i className="bi bi-buildings text-warning fs-4"></i>
            </div>
            <div>
              <div className="fw-bold text-white lh-1" style={{ fontSize: '0.95rem' }}>SIMRS2 <span className="text-teal" style={{ fontSize: '0.78rem' }}>Finance</span></div>
              <div className="text-white-50 small" style={{ fontSize: '0.62rem' }}>Sistem Informasi Rumah Sakit</div>
            </div>
          </a>
          
          <div className="d-flex align-items-center text-white text-end gap-3 ms-auto">
            <div className="small border-end pe-3 border-light border-opacity-25 d-none d-sm-block">
              <div className="fw-semibold text-white-50" style={{ fontSize: '0.73rem' }}>{time.date}</div>
              <div className="fw-bold text-teal" style={{ fontSize: '0.78rem' }}>{time.clock}</div>
            </div>
            <Button variant="light" size="sm" onClick={() => navigate('/home')} className="d-flex align-items-center gap-1">
              <i className="bi bi-house-door-fill text-teal"></i>
              <span>Kembali</span>
            </Button>
          </div>
        </Container>
      </nav>

      {/* CORE MAIN CONTENT */}
      <div style={styles.mainContent}>
        <Row className="g-3 h-100 flex-grow-1">
          <Col lg={12}>
            <Card style={styles.mainCard} className="shadow-sm border-0 h-100">
              <div style={styles.cardHeader} className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                <span className="fw-bold"><i className="bi bi-building-fill-check me-1 text-warning"></i> Master Perusahaan & Perujuk</span>
                <Button variant="outline-light" size="sm" onClick={() => activeTab === 'perusahaan' ? fetchPerusahaan() : fetchPerujuk()} disabled={isLoading} style={{ fontSize: '0.7rem' }}>
                  {isLoading ? <Spinner size="sm" animation="border" /> : <i className="bi bi-arrow-clockwise"></i>} Reload
                </Button>
              </div>

              <Card.Body className="p-3 d-flex flex-column h-100" style={{ minHeight: 0 }}>
                {/* TABS */}
                <div className="d-flex gap-2 mb-3 border-bottom pb-2">
                  <Button 
                    variant={activeTab === 'perusahaan' ? 'primary' : 'light'} 
                    size="sm" 
                    onClick={() => setActiveTab('perusahaan')}
                    className="fw-bold"
                  >
                    <i className="bi bi-building me-1"></i> Data Perusahaan
                  </Button>
                  <Button 
                    variant={activeTab === 'perujuk' ? 'success' : 'light'} 
                    size="sm" 
                    onClick={() => setActiveTab('perujuk')}
                    className="fw-bold"
                  >
                    <i className="bi bi-person-hearts me-1"></i> Data Perujuk
                  </Button>
                </div>


                {activeTab === 'perusahaan' ? (
                  <>
                    {/* Search Bar & Filter Row */}
                <Row className="g-2 mb-3">
                  <Col md={5}>
                    <InputGroup size="sm">
                      <InputGroup.Text className="bg-light border-end-0"><i className="bi bi-search text-muted"></i></InputGroup.Text>
                      <Form.Control 
                        placeholder="Cari kode, nama perusahaan, atau PIC..." 
                        value={searchQuery}
                        onChange={(e) => { setSearchQuery(e.target.value); setCurrentPage(1); }}
                        className="border-start-0 ps-0"
                        style={{ fontSize: '0.78rem' }}
                      />
                      {searchQuery && (
                        <Button variant="outline-secondary" className="border-start-0" onClick={() => setSearchQuery('')}>
                          <i className="bi bi-x"></i>
                        </Button>
                      )}
                    </InputGroup>
                  </Col>
                  <Col md={5} className="d-flex align-items-center">
                    <span className="text-muted" style={{ fontSize: '0.75rem' }}>
                      Menampilkan <strong className="text-dark">{filteredData.length}</strong> data perusahaan
                    </span>
                  </Col>
                  <Col md={2} className="text-end">
                    <Form.Select 
                      size="sm" 
                      value={itemsPerPage} 
                      onChange={(e) => { setItemsPerPage(Number(e.target.value)); setCurrentPage(1); }}
                      style={{ fontSize: '0.78rem' }}
                    >
                      <option value={15}>15 Baris</option>
                      <option value={30}>30 Baris</option>
                      <option value={50}>50 Baris</option>
                      <option value={100}>100 Baris</option>
                    </Form.Select>
                  </Col>
                </Row>

                {/* Table Area */}
                {fetchError && (
                  <div className="alert alert-warning py-1.5 px-3 mb-2.5" style={{ fontSize: '0.75rem' }}>
                    <i className="bi bi-exclamation-triangle-fill me-1"></i> {fetchError}
                  </div>
                )}

                <div className="table-responsive flex-grow-1 border rounded" style={{ overflowY: 'auto', minHeight: '380px', backgroundColor: '#fff' }}>
                  <Table striped hover size="sm" className="align-middle mb-0" style={{ fontSize: '0.76rem' }}>
                    <thead className="table-light text-secondary sticky-top" style={{ zIndex: 1 }}>
                      <tr>
                        <th style={{ width: '50px', textAlign: 'center', padding: '6px 10px' }}>No</th>
                        <th style={{ width: '80px', padding: '6px 10px' }}>Kode</th>
                        <th style={{ minWidth: '220px', padding: '6px 10px' }}>Nama Perusahaan</th>
                        <th style={{ minWidth: '200px', padding: '6px 10px' }}>Alamat</th>
                        <th style={{ width: '130px', padding: '6px 10px' }}>Kontak</th>
                        <th style={{ width: '130px', padding: '6px 10px' }}>PIC</th>
                        <th style={{ width: '80px', textAlign: 'center', padding: '6px 10px' }}>Tempo</th>
                      </tr>
                    </thead>
                    <tbody>
                      {isLoading ? (
                        <tr>
                          <td colSpan="7" className="text-center py-5 text-muted">
                            <Spinner animation="border" variant="teal" className="mb-2" />
                            <div>Memuat data perusahaan...</div>
                          </td>
                        </tr>
                      ) : currentItems.length > 0 ? (
                        currentItems.map((item, idx) => {
                          const isNoAlamat = item.jln === '-' && item.gedung === '-' && item.kawasan === '-';
                          const alamatStr = isNoAlamat ? '-' : `${item.jln !== '-' ? item.jln : ''} ${item.nomor !== '-' ? 'No.' + item.nomor : ''} ${item.gedung !== '-' ? item.gedung : ''} ${item.kawasan !== '-' ? item.kawasan : ''}`.trim();
                          
                          const hasTelp = item.telp11 && item.telp11 !== '-';
                          const hasEmail = item.email1 && item.email1 !== '-';

                          return (
                            <tr key={idx}>
                              <td className="text-center text-muted fw-bold" style={{ padding: '5px 10px' }}>{indexOfFirstItem + idx + 1}</td>
                              <td className="fw-bold font-monospace text-teal" style={{ padding: '5px 10px' }}>{item.kode}</td>
                              <td className="fw-bold text-dark" style={{ padding: '5px 10px' }}>{item.perusahaan}</td>
                              <td className="text-muted" style={{ padding: '5px 10px' }}>
                                <div style={{ maxWidth: '280px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={alamatStr}>
                                  {alamatStr}
                                </div>
                              </td>
                              <td style={{ padding: '5px 10px' }}>
                                {hasTelp ? <div><i className="bi bi-telephone-fill text-muted me-1"></i> {item.telp11}</div> : null}
                                {hasEmail ? <div className="text-primary"><i className="bi bi-envelope-fill text-muted me-1"></i> {item.email1}</div> : null}
                                {!hasTelp && !hasEmail && <span className="text-muted">-</span>}
                              </td>
                              <td style={{ padding: '5px 10px' }}>
                                {item.pic1 !== '-' && <div>{item.pic1}</div>}
                                {item.pic2 !== '-' && <div>{item.pic2}</div>}
                                {item.pic1 === '-' && item.pic2 === '-' && <span className="text-muted">-</span>}
                              </td>
                              <td className="text-center" style={{ padding: '5px 10px' }}>
                                <span className="badge bg-light text-dark border fw-bold" style={{ fontSize: '0.72rem' }}>
                                  {item.bayar} Hari
                                </span>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="7" className="text-center py-5 text-muted">
                            <i className="bi bi-inbox fs-2 d-block mb-2 opacity-50"></i>
                            Tidak ada data perusahaan yang sesuai.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>

                {/* Footer Pagination */}
                {totalPages > 1 && (
                  <div className="d-flex justify-content-between align-items-center mt-3 pt-2 border-top">
                    <div className="text-muted" style={{ fontSize: '0.75rem' }}>
                      Halaman <strong className="text-dark">{currentPage}</strong> dari <strong>{totalPages}</strong>
                    </div>
                    <div className="d-flex gap-1">
                      <Button variant="outline-secondary" size="sm" onClick={() => setCurrentPage(1)} disabled={currentPage === 1} style={{ padding: '2px 8px', fontSize: '0.75rem' }}>&laquo;</Button>
                      <Button variant="outline-secondary" size="sm" onClick={() => setCurrentPage(p => Math.max(1, p - 1))} disabled={currentPage === 1} style={{ padding: '2px 8px', fontSize: '0.75rem' }}>&lsaquo;</Button>
                      <Button variant="outline-secondary" size="sm" onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))} disabled={currentPage === totalPages} style={{ padding: '2px 8px', fontSize: '0.75rem' }}>&rsaquo;</Button>
                      <Button variant="outline-secondary" size="sm" onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages} style={{ padding: '2px 8px', fontSize: '0.75rem' }}>&raquo;</Button>
                    </div>
                  </div>
                )}
                  </>
                ) : (
                  <div className="d-flex flex-column h-100">
                    <Row className="g-2 mb-3">
                      <Col md={5}>
                        <InputGroup size="sm">
                          <InputGroup.Text className="bg-light border-end-0"><i className="bi bi-search text-muted"></i></InputGroup.Text>
                          <Form.Control 
                            placeholder="Cari kode, nama perujuk, atau tempat praktek..." 
                            value={searchPerujuk}
                            onChange={(e) => setSearchPerujuk(e.target.value)}
                            className="border-start-0 ps-0"
                            style={{ fontSize: '0.78rem' }}
                          />
                          {searchPerujuk && (
                            <Button variant="outline-secondary" className="border-start-0" onClick={() => setSearchPerujuk('')}>
                              <i className="bi bi-x"></i>
                            </Button>
                          )}
                        </InputGroup>
                      </Col>
                      <Col md={7} className="d-flex align-items-center">
                        <span className="text-muted" style={{ fontSize: '0.75rem' }}>
                          Menampilkan <strong className="text-dark">{filteredPerujuk.length}</strong> data perujuk
                        </span>
                      </Col>
                    </Row>

                    {fetchError && (
                      <div className="alert alert-warning py-1.5 px-3 mb-2.5" style={{ fontSize: '0.75rem' }}>
                        <i className="bi bi-exclamation-triangle-fill me-1"></i> {fetchError}
                      </div>
                    )}

                    <div className="table-responsive flex-grow-1 border rounded" style={{ overflowY: 'auto', minHeight: '380px', backgroundColor: '#fff' }}>
                      <Table striped hover size="sm" className="align-middle mb-0" style={{ fontSize: '0.76rem' }}>
                        <thead className="table-light text-secondary sticky-top" style={{ zIndex: 1 }}>
                          <tr>
                            <th style={{ width: '50px', textAlign: 'center', padding: '6px 10px' }}>No</th>
                            <th style={{ width: '80px', padding: '6px 10px' }}>Kode</th>
                            <th style={{ minWidth: '200px', padding: '6px 10px' }}>Nama Perujuk</th>
                            <th style={{ minWidth: '180px', padding: '6px 10px' }}>Tempat Praktik</th>
                            <th style={{ minWidth: '220px', padding: '6px 10px' }}>Alamat</th>
                            <th style={{ width: '150px', padding: '6px 10px' }}>Sales</th>
                            <th style={{ width: '100px', padding: '6px 10px' }}>SIP/SIK</th>
                          </tr>
                        </thead>
                        <tbody>
                          {isLoadingPerujuk ? (
                            <tr>
                              <td colSpan="7" className="text-center py-5 text-muted">
                                <Spinner animation="border" variant="success" className="mb-2" />
                                <div>Memuat data perujuk...</div>
                              </td>
                            </tr>
                          ) : filteredPerujuk.length > 0 ? (
                            filteredPerujuk.map((item, idx) => (
                              <tr key={idx}>
                                <td className="text-center text-muted fw-bold" style={{ padding: '5px 10px' }}>{idx + 1}</td>
                                <td className="fw-bold font-monospace text-success" style={{ padding: '5px 10px' }}>{item.kd_rujuk}</td>
                                <td className="fw-bold text-dark" style={{ padding: '5px 10px' }}>{item.nama}</td>
                                <td className="text-muted" style={{ padding: '5px 10px' }}>{item.praktek || '-'}</td>
                                <td className="text-muted" style={{ padding: '5px 10px' }}>
                                  <div style={{ maxWidth: '220px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={item.alamat || '-'}>
                                    {item.alamat || '-'}
                                  </div>
                                </td>
                                <td style={{ padding: '5px 10px' }}>
                                  {item.nm_sales ? <div><i className="bi bi-person-fill text-muted me-1"></i> {item.nm_sales}</div> : <span className="text-muted">-</span>}
                                </td>
                                <td style={{ padding: '5px 10px', fontSize: '0.7rem' }}>
                                  {item.sip && <div>SIP: {item.sip}</div>}
                                  {item.sik && <div>SIK: {item.sik}</div>}
                                  {!item.sip && !item.sik && <span className="text-muted">-</span>}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="7" className="text-center py-5 text-muted">
                                <i className="bi bi-inbox fs-2 d-block mb-2 opacity-50"></i>
                                Tidak ada data perujuk yang sesuai.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </div>
                  </div>
                )}

              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default MasterPerusahaan;
